import { FC } from 'react';
import { SbSharedStorefrontCreatorLink_browseContentModule } from './__generated__/SbSharedStorefrontCreatorLink_browseContentModule.graphql';

import { SbSharedStorefrontLinkBase } from './SbSharedStorefrontLinkBase';
import { createFragmentContainer, graphql } from 'react-relay/legacy';

type Props = {
    browseContentModule: SbSharedStorefrontCreatorLink_browseContentModule;
};

const SbSharedStorefrontCreatorLinkComponent: FC<Props> = ({ browseContentModule }) => {
    return <SbSharedStorefrontLinkBase browseContentModule={browseContentModule} />;
};

export const SbSharedStorefrontCreatorLink = createFragmentContainer(
    SbSharedStorefrontCreatorLinkComponent,
    {
        browseContentModule: graphql`
            fragment SbSharedStorefrontCreatorLink_browseContentModule on ContentModuleCreator {
                seller {
                    sellerProfile {
                        company
                    }
                    sellerPreferences {
                        urlLabel
                    }
                    liveStorefrontProfile {
                        status
                    }
                }
            }
        `,
    }
);
